import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllRequisicaoProdutoServicoUseCase } from "../../../presentation/useCases/read/get_all_requisicao_produto_servico_use_case";
import { RequisicaoProdutoServicoLista } from "../../models/requisicao_produto_servico_lista";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllRequisicaoProdutoServicoUseCase
 */

export class GetAllRequisicaoProdutoServicoUseCase
  extends BasePaginatedUseCase<RequisicaoProdutoServicoLista>
  implements IGetAllRequisicaoProdutoServicoUseCase {
  constructor(private readonly repository: IComprasRepository) {
    super();
  }

  async getAllRequisicaoProdutoServico(
    idRequisicaoCompra: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idRequisicaoCompra === undefined) throw new Error('Falha ao buscar id da requisição de compra!');

    const response = await this.repository.getAllRequisicaoProdutoServico(
      idRequisicaoCompra,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
